import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import { ProductStatusLabel, CardImage, statusColorMapping, CardPrice, InfoBox } from "../../../index.js";
import { ProductCard } from "../ProductCard/ProductCard";
import { Flex, Box, Text, useBreakpointValue } from '@chakra-ui/react';
import { CardVlp, getInnerComponent } from "../CardVlp/CardVlp";
var BANNER_BACKGROUND_COLORS = {
  yellow: 'var(--chakra-colors-yellow-500, #FFDC00)',
  grey: 'var(--chakra-colors-grey-100, #EEEDE9)',
  white: 'white'
};
var mobileCircleStyles = {
  content: "''",
  position: 'absolute',
  bottom: '0',
  left: '50%',
  transform: 'translate(-50%, 0%)',
  backgroundColor: 'white',
  height: 'auto',
  minHeight: '400px',
  paddingBottom: '1130px',
  width: '1130px',
  minWidth: 'calc(3*100%)',
  borderRadius: '100%'
};
var desktopCircleStyles = {
  content: "''",
  position: 'absolute',
  top: '50%',
  right: 0,
  transform: 'translate(0%, -50%)',
  backgroundColor: 'white',
  height: 'calc(100% + 300px)',
  paddingBottom: 'calc(100% + 300px)',
  width: 'auto',
  minWidth: '700px',
  borderRadius: '100%'
};
var CTA_VARIANTS = {
  primary: 'primarySmall',
  secondary: 'secondarySmall',
  link: 'iconLink'
};
export var ProductBanner = function ProductBanner(props) {
  var bannerColor = props.bannerColor,
    item = props.item,
    disabled = props.disabled,
    translations = props.translations,
    format = props.format,
    lang = props.lang,
    fullPriceProps = props.fullPriceProps,
    title = props.title,
    image = props.image,
    availabilityStatus = props.availabilityStatus,
    _props$link = props.link,
    link = _props$link === void 0 ? '#' : _props$link,
    _props$target = props.target,
    target = _props$target === void 0 ? '_self' : _props$target;
  // console.log(CTA_VARIANTS[item?.buttonLink?.variant] + 'here');
  // if (item?.buttonLink?.variant) {
  //   item.buttonLink.variant = CTA_VARIANTS[item.buttonLink.variant]
  // }

  var bannerBackgroundColor = BANNER_BACKGROUND_COLORS[bannerColor];
  var isMobile = useBreakpointValue({
    base: true,
    md: false
  });
  var disabledKey = disabled && translations.temporarilyDisabled;
  return /*#__PURE__*/React.createElement(Flex, {
    width: "100%",
    gap: "8px",
    flexDirection: {
      base: 'column',
      md: 'row'
    },
    justifyContent: "space-between",
    alignContent: "center",
    bg: {
      base: bannerBackgroundColor,
      md: "linear-gradient(to right, ".concat(BANNER_BACKGROUND_COLORS.white, " 20%, ").concat(bannerBackgroundColor, " 10%, ").concat(bannerBackgroundColor, " 70%)")
    },
    boxShadow: "var(--chakra-shadows-default, 0px 1px 2px rgba(0, 0, 0, 0.2), 0px 1px 3px rgba(0, 0, 0, 0.1))",
    borderRadius: "8px",
    "data-testid": "molecules-ProductBanner-Flex"
  }, /*#__PURE__*/React.createElement("a", {
    style: {
      flex: 1
    },
    d: "flex",
    href: link,
    target: target,
    "data-testid": "molecules-ProductBanner-a"
  }, /*#__PURE__*/React.createElement(Flex, {
    position: "relative",
    p: {
      base: '30px 16px',
      md: '24px'
    },
    w: "100%",
    h: "100%",
    overflow: "hidden",
    _before: isMobile ? mobileCircleStyles : desktopCircleStyles
  }, /*#__PURE__*/React.createElement(Box, {
    w: {
      base: '127px',
      md: '155px'
    },
    h: {
      base: '127px',
      md: '155px'
    },
    m: "auto 0",
    mr: "16px",
    borderRadius: "8px",
    "data-testid": "molecules-ProductBanner-Box"
  }, /*#__PURE__*/React.createElement(ProductCard.Image, null, /*#__PURE__*/React.createElement("div", {
    className: "relative"
  }, /*#__PURE__*/React.createElement(CardImage, {
    alt: title,
    source: image,
    title: title
  })))), /*#__PURE__*/React.createElement(Box, {
    zIndex: 1,
    m: "auto 0"
  }, /*#__PURE__*/React.createElement(ProductCard.Title, null, /*#__PURE__*/React.createElement(Text, {
    fontSize: "sm",
    fontFamily: "bold",
    lineHeight: "21px"
  }, title)), /*#__PURE__*/React.createElement(ProductCard.Extra, null, availabilityStatus || disabledKey ? /*#__PURE__*/React.createElement(ProductStatusLabel, {
    disabledKey: disabledKey,
    availabilityStatus: availabilityStatus,
    color: statusColorMapping(availabilityStatus, disabledKey)
  }) : /*#__PURE__*/React.createElement(Text, null, props === null || props === void 0 ? void 0 : props.category)), fullPriceProps.isVLP && /*#__PURE__*/React.createElement(Box, {
    sx: {
      'div:first-of-type': {
        flexDirection: 'row',
        maxWidth: '100%',
        justifyContent: 'flex-start',
        flexWrap: 'nowrap',
        height: 'auto',
        width: 'auto',
        lineHeight: 'normal'
      }
    }
  }, /*#__PURE__*/React.createElement(CardVlp, {
    "data-testid": "molecules-ProductBanner-CardVlp"
  }, getInnerComponent(format, lang, translations.vlp))), !disabledKey && /*#__PURE__*/React.createElement(Box, {
    pt: "8px"
  }, /*#__PURE__*/React.createElement(CardPrice, _extends({}, fullPriceProps, {
    "data-testid": "molecules-ProductBanner-CardPrice"
  })))))), /*#__PURE__*/React.createElement(Box, {
    flex: "1",
    p: {
      base: '24px 0 20px'
    },
    sx: {
      '& > div': {
        marginRight: '24px',
        '& > a': {
          width: 'auto'
        }
      }
    }
  }, /*#__PURE__*/React.createElement(InfoBox, {
    item: _objectSpread(_objectSpread({}, item), {}, {
      buttonLink: _objectSpread(_objectSpread({}, item.buttonLink), {}, {
        variant: CTA_VARIANTS[item.buttonLink.variant]
      })
    }),
    isProduct: true,
    "data-testid": "molecules-ProductBanner-InfoBox"
  })));
};